'use strict';

import { enableSelectFloating } from '../components/selectFloatingLabel';
import { enableTogglePassword } from '../togglePassword';
const { ajaxFormInvalid, ajaxFormSubmit, enableFormSubmitButton, sheetFormSubmit } = require('../clientSideValidation');

const { queryFirst, queryAll, validateDate } = require('../domUtil');
const { appendToUrl, formatPhoneNumber } = require('../util');

const accountSheetContainer = queryFirst('#account-sheet');
const $body = $('body');
/**
 * inject content for the current profile details sheet
 * @param {Array} components - html sheets to inject
 */
function injectSheetContent(components) {
    const modalBody = queryFirst('.js-account-sheet-container', accountSheetContainer);
    components.forEach(component => modalBody.appendChild(component));
}

/**
 * Initialize form events and add necessary behaviors to the form
 * @param {[HTMLElement]} components - The components to be injected into the form
 */
function initFormEvents(components) {
    ajaxFormInvalid('.enable-form-validate');
    ajaxFormSubmit('.enable-form-validate');
    enableFormSubmitButton();
    sheetFormSubmit();
    validateDate();
    enableSelectFloating();
    enableTogglePassword();
    components.forEach(component => {
        const form = queryFirst('form', component);
        const phoneNumberEl = queryFirst('.registration-form-phone', form);
        if (phoneNumberEl) {
            formatPhoneNumber(phoneNumberEl);
        }
    });
    $body.trigger('sheet:injectForm');
}
/**
 * load sheed data from server
 */
export async function loadSheetData() {
    const config = queryFirst('.js-account-sheet-config')?.dataset;
    const accountSheets = queryAll('.js-container', accountSheetContainer);
    if (accountSheets.length) return; // if sheets loaded avoid loading
    if (!config) return;
    const res = await fetch(
        appendToUrl(config.href, {
            isAjax: true
        })
    );
    if (!res.ok) throw new Error('response was not OK');

    const resText = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(resText, 'text/html');
    const components = queryAll('.js-container', doc);
    if (components) injectSheetContent(components);
    initFormEvents(components);
}

/**
 * Clear sheet
 */
export function clearSheet() {
    const modalBody = queryFirst('.js-account-sheet-container', accountSheetContainer);
    modalBody.replaceChildren();
}
